module.exports = __webpack_public_path__ + "static/media/Tumblr.44072d2c.png";